import apiClient from '../apiClient';
import { POST_PLACE_URL } from '../apiUrl';

const postPlaceApi = data => {
  return apiClient.post(POST_PLACE_URL, data);
};

export default postPlaceApi;
